import { Routes } from '@angular/router'
import { AppLayoutComponent } from './layout/feature/layout/app-layout.component'
import { authGuard } from './core/guards/auth.guard'
import { NotFoundComponent } from './error-pages/feature/not-found/not-found.component'
import {
  ChantierUnauthorizedComponent
} from "./error-pages/feature/chantier-unauthorized/chantier-unauthorized.component";
import {globalResolver} from "./core/resolvers/global.resolver";

export const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard()],
    resolve: {data:globalResolver()},
    children: [
      { path: '', loadChildren: () => import('./home/feature/home.routes').then((m) => m.HOME_ROUTES)},
      { path: 'not-found', component: NotFoundComponent },
      { path: 'unauthorized-chantier/:codeChantier', component: ChantierUnauthorizedComponent },
    ],
  },
  { path: '**', redirectTo: 'not-found' },
]
